/* eslint-disable import/no-extraneous-dependencies */
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import Loader from './components/Loader';
import { store, persistor } from './redux/store';

const LazzyApp = React.lazy(() => import('./App'));

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
    <Suspense fallback={<Loader />}>
      <React.StrictMode>
        <LazzyApp />
      </React.StrictMode>
    </Suspense>
    </PersistGate>
  </Provider>,
);
